export default {
  GET_MY_STATISTICS_REQUEST: 'GET_MY_STATISTICS_REQUEST',

  SET_USER_STATISTIC: 'SET_USER_STATISTIC',
};
